// Accordion
var Accordion = {

	selector: '.accordion',
	selectorHead: '.accordion-head',
	buttonSelector: '.accordion-button',
	contentSelector: '.accordion-content',
	selectorNoDesk: '[data-accordion-mobile]',
	windowSize: window.innerWidth,
	duration: 250,
	destroyDesk: false,

	init: function () {

		if (!$(this.selector).length) return;

		this.bindAccordion();
		this.bindChangeEvent();
		if (Accordion.windowSize > 719) {
			Accordion.destroyDesk = true;
			this.destroyAccordion();
		} else {
			Accordion.destroyDesk = false;
		}
	},

	bindAccordion: function () {

		// initialize table scroll
		TableScroll.init();

		// add IDs to the accordion list items
		this.addIDs();

		// unbind click event to fix the bug in news&event page where the function is called twice
		this.unbindAllClickEvents();

		// bind click events for toggle
		this.bindClickEvents();

	},

	bindChangeEvent: function () {

		$(window).on('orientationchange resize', function () {

			// Throttle the resize event to fix adroid bug
			clearTimeout(this.id);
			this.id = setTimeout(function () {
				if (Accordion.windowSize !== window.innerWidth) {

					// Update the width variable
					Accordion.updateWindowSize();

					if (Accordion.windowSize > 719) {

						Accordion.destroyDesk = true;
						Accordion.destroyAccordion();

					} else {
						Accordion.destroyDesk = false;
						Accordion.reset();
					}
				}
			}, 10);

		});
	},

	updateWindowSize: function () {

		// get window width and update the global value
		Accordion.windowSize = window.innerWidth;

	},

	reset: function () {
		Accordion.unbindAllClickEvents();
		$(Accordion.contentSelector).removeAttr('style');
		Accordion.bindAccordion();
	},

	destroyAccordion: function () {

		if (Accordion.destroyDesk) {

			$(Accordion.selectorNoDesk).each(function (i) {

				var $thisList = $(this),
					$thisItems = $thisList.children('li'),
					$thistHeads = $thisItems.children('.accordion-head'),
					$thisButtons = $thistHeads.find('.accordion-button'),
					$thisContent = $thisList.find('.accordion-content');

				$thisButtons.removeAttr('aria-expanded');
				$thisButtons.removeAttr('aria-controls');
				$thisContent.removeAttr('aria-hidden');
				$thisContent.removeAttr('id');

				Accordion.unbindClickEvents($thisButtons);

			});

		} else {
			Accordion.reset();
		}
	},

	addIDs: function () {

		// get all <li> elements within an accordion
		var $accordions = $('.accordion'),
			$listItems = $accordions.children('li'),
			$listHead = $listItems.children('.accordion-head'),
			$listButtons = $listHead.find('.accordion-button'),
			$listContent = $listItems.find('.accordion-content');

		// add an IDs to each list
		$listItems.each(function (i) {

			var $thisList = $(this);

			// add id to list item
			$thisList.attr('id', 'item-' + i);

		});

		$listButtons.each(function (i) {

			var $thisButton = $(this),
				parentId = $thisButton.parents('li').attr('id');

			// add IDs aria attributes
			$thisButton.attr('aria-controls', 'content-' + parentId);
			$thisButton.attr('aria-expanded', false);

		});

		$listContent.each(function (i) {

			var $thisContent = $(this),
				parentId = $thisContent.parent('li').attr('id');

			// add IDs to the content 
			$thisContent.attr('id', 'content-' + parentId);
			$thisContent.attr('aria-hidden', true);

		});

	},

	bindClickEvents: function () {

		$(Accordion.buttonSelector).on('click', function (e) {

			var $this = $(this);
			var $thisParent = $this.parents('li');
			var $thisContent = $thisParent.find('.accordion-content');

			// update accordion state
			Accordion.activateAccordion($this, $thisContent);

			// prevent default click behavior
			e.preventDefault();
			// stopPropagation to prevent the button click from bubbling up the DOM
			e.stopPropagation();

		});
	},

	unbindClickEvents: function ($thisButtons) {
		$thisButtons.off("click");
	},

	unbindAllClickEvents: function () {
		$(Accordion.buttonSelector).off('click');
	},

	activateAccordion: function ($this, $thisContent) {

		var state = $this.attr('aria-expanded') === 'false' ? true : false;

		// set aria attribute state
		$this.attr('aria-expanded', state);

		// animate height
		$thisContent.slideToggle(Accordion.duration, function () {

			// set aria-hidden state and focus
			$thisContent.attr('aria-hidden', !state);

		});

	}

};

$(document).ready(function () {
	Accordion.init();
});